import { useState, useRef } from "react";

// ─── CONSTANTS ────────────────────────────────────────────────────────────────
const USER = { name: "SR Kashyap", email: "pentoshamitha@gmail.com", initials: "SK" };

const INITIAL_SUBS = [
  { id:1, name:"Netflix",         plan:"4K Ultra HD · 4 screens",  icon:"🎬", price:649, cycle:"month", nextDate:"May 6",  daysLeft:2,  autopay:true,  category:"entertainment", usageLabel:"Monthly usage",  usageVal:"22h 40m / 40h",     usagePct:56, color:"#ff0050", bg:"rgba(255,0,80,0.12)",    trend:[400,420,430,410,440,460,480,500,520,540,560,649] },
  { id:2, name:"Spotify",         plan:"Premium Individual",        icon:"🎵", price:119, cycle:"month", nextDate:"May 8",  daysLeft:4,  autopay:true,  category:"music",          usageLabel:"Monthly usage",  usageVal:"87h / Unlimited",    usagePct:87, color:"#1ed760", bg:"rgba(30,215,96,0.12)",   trend:[99,99,99,99,99,99,99,99,99,99,119,119] },
  { id:3, name:"Amazon Prime",    plan:"Annual Plan",               icon:"📺", price:299, cycle:"month", nextDate:"May 18", daysLeft:14, autopay:true,  category:"entertainment", usageLabel:"Monthly usage",  usageVal:"14h / Unlimited",    usagePct:35, color:"#f7971e", bg:"rgba(255,170,0,0.12)",   trend:[249,249,249,249,299,299,299,299,299,299,299,299] },
  { id:4, name:"iCloud Storage",  plan:"50GB Plan",                 icon:"☁️", price:75,  cycle:"month", nextDate:"May 11", daysLeft:7,  autopay:true,  category:"cloud",          usageLabel:"Storage used",   usageVal:"38.2 GB / 50 GB",   usagePct:76, color:"#007aff", bg:"rgba(0,122,255,0.12)",   trend:[75,75,75,75,75,75,75,75,75,75,75,75] },
  { id:5, name:"YouTube Premium", plan:"Individual",                icon:"▶️", price:189, cycle:"month", nextDate:"May 22", daysLeft:18, autopay:false, category:"entertainment", usageLabel:"Monthly usage",  usageVal:"31h / Unlimited",    usagePct:62, color:"#ff0000", bg:"rgba(255,0,0,0.12)",     trend:[159,159,159,189,189,189,189,189,189,189,189,189] },
  { id:6, name:"Notion Pro",      plan:"Personal Plan",             icon:"📝", price:325, cycle:"month", nextDate:"Jun 1",  daysLeft:28, autopay:true,  category:"work",           usageLabel:"Pages / blocks", usageVal:"1,240 blocks used", usagePct:40, color:"#eeeeee", bg:"rgba(255,255,255,0.06)", trend:[280,280,280,280,280,325,325,325,325,325,325,325] },
  { id:7, name:"Figma",           plan:"Professional",              icon:"🎨", price:540, cycle:"month", nextDate:"Jun 5",  daysLeft:32, autopay:true,  category:"work",           usageLabel:"Projects",       usageVal:"8 / 10 projects",   usagePct:80, color:"#a259ff", bg:"rgba(162,89,255,0.12)",  trend:[400,400,450,450,450,540,540,540,540,540,540,540] },
  { id:8, name:"Apple Music",     plan:"Individual",                icon:"🍎", price:99,  cycle:"month", nextDate:"Jun 10", daysLeft:37, autopay:false, category:"music",          usageLabel:"Monthly usage",  usageVal:"12h / Unlimited",    usagePct:20, color:"#fc3c44", bg:"rgba(252,60,68,0.12)",   trend:[99,99,99,99,99,99,99,99,99,99,99,99] },
];

const TRANSACTIONS = [
  { id:1, name:"Netflix Autopay",     date:"Today, 12:00 AM · Auto", amount:-649,  icon:"🎬", bg:"rgba(255,0,80,0.1)" },
  { id:2, name:"Spotify Premium",     date:"Yesterday · Auto",        amount:-119,  icon:"🎵", bg:"rgba(30,215,96,0.1)" },
  { id:3, name:"Received from Priya", date:"2 May · UPI",             amount:2000,  icon:"💸", bg:"rgba(67,233,123,0.1)" },
  { id:4, name:"iCloud Storage",      date:"1 May · Auto",            amount:-75,   icon:"☁️", bg:"rgba(0,122,255,0.1)" },
  { id:5, name:"Sent to Swiggy",      date:"30 Apr · UPI",            amount:-340,  icon:"🛍️", bg:"rgba(108,99,255,0.1)" },
];

const MONTHS = ["May","Jun","Jul","Aug","Sep","Oct","Nov","Dec","Jan","Feb","Mar","Apr"];
const CATEGORIES = ["all","entertainment","music","cloud","work"];
const TNR = "'Times New Roman', Times, serif";

const G = {
  bg:"#0a0a0f", surface:"#13131a", surface2:"#1c1c28", border:"#2a2a3d",
  accent:"#6c63ff", accent2:"#ff6584", accent3:"#43e97b", accent4:"#f7971e",
  text:"#f0f0f8", muted:"#7070a0", card:"#16161f",
};

const css = `
  *{margin:0;padding:0;box-sizing:border-box}
  body{background:${G.bg};color:${G.text};font-family:${TNR}}
  ::-webkit-scrollbar{width:4px}
  ::-webkit-scrollbar-thumb{background:${G.border};border-radius:2px}
  .pv-shell{max-width:430px;margin:0 auto;min-height:100vh;display:flex;flex-direction:column;background:${G.bg};box-shadow:0 0 80px rgba(108,99,255,0.12);}
  @keyframes fadeUp{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}
  @keyframes popIn{from{transform:scale(0.5);opacity:0}to{transform:scale(1);opacity:1}}
  .fade-up{animation:fadeUp 0.3s ease}
  .pop-in{animation:popIn 0.4s cubic-bezier(0.4,0,0.2,1)}
  input,select{outline:none;font-family:${TNR}}
  button{cursor:pointer;font-family:${TNR}}
  .hover-card:hover{border-color:rgba(108,99,255,0.4)!important}
`;

// ─── SHARED COMPONENTS ────────────────────────────────────────────────────────
function Toggle({ on, onChange }) {
  return (
    <div onClick={()=>onChange(!on)} style={{width:44,height:24,borderRadius:12,background:on?G.accent3:G.border,position:"relative",cursor:"pointer",transition:"background 0.2s",flexShrink:0}}>
      <div style={{width:18,height:18,borderRadius:"50%",background:"#fff",position:"absolute",top:3,left:on?23:3,transition:"left 0.2s",boxShadow:"0 1px 4px rgba(0,0,0,0.3)"}}/>
    </div>
  );
}

function Modal({ open, onClose, children }) {
  if (!open) return null;
  return (
    <div onClick={e=>e.target===e.currentTarget&&onClose()} style={{position:"fixed",inset:0,zIndex:999,background:"rgba(0,0,0,0.78)",backdropFilter:"blur(6px)",display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div style={{width:"100%",maxWidth:430,background:G.surface,borderRadius:"24px 24px 0 0",padding:"20px 20px 44px",maxHeight:"92vh",overflowY:"auto",animation:"fadeUp 0.25s ease"}}>
        {/* Handle + X button */}
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",position:"relative",marginBottom:20}}>
          <div style={{width:40,height:4,borderRadius:2,background:G.border}}/>
          <button onClick={onClose} style={{position:"absolute",right:0,top:"50%",transform:"translateY(-50%)",width:30,height:30,borderRadius:"50%",background:G.surface2,border:`1px solid ${G.border}`,color:G.muted,fontSize:15,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

function UsageBar({ pct, color }) {
  return (
    <div style={{height:6,borderRadius:10,background:G.border,overflow:"hidden"}}>
      <div style={{height:"100%",width:`${pct}%`,borderRadius:10,background:color,transition:"width 1s"}}/>
    </div>
  );
}

function SectionTitle({ children, action, onAction }) {
  return (
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
      <div style={{fontFamily:TNR,fontWeight:700,fontSize:15}}>{children}</div>
      {action && <div style={{fontSize:13,color:G.accent,cursor:"pointer"}} onClick={onAction}>{action}</div>}
    </div>
  );
}

// ─── CANCEL CONFIRM MODAL ─────────────────────────────────────────────────────
function CancelConfirmModal({ open, sub, onConfirm, onClose }) {
  if (!sub) return null;
  return (
    <Modal open={open} onClose={onClose}>
      <div style={{textAlign:"center",padding:"8px 0 16px"}}>
        <div style={{fontSize:52,marginBottom:12}}>⚠️</div>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:10}}>Cancel Subscription?</div>
        <div style={{fontSize:14,color:G.muted,marginBottom:4}}>
          You are about to cancel <span style={{color:G.text,fontWeight:700}}>{sub.icon} {sub.name}</span>
        </div>
        <div style={{fontSize:13,color:G.muted,marginBottom:24}}>₹{sub.price}/{sub.cycle} · Next due {sub.nextDate}</div>
        <div style={{display:"flex",gap:12}}>
          <button onClick={onClose} style={{flex:1,padding:14,borderRadius:14,background:G.surface2,border:`1px solid ${G.border}`,color:G.text,fontSize:15,fontWeight:600}}>Keep It</button>
          <button onClick={()=>{onConfirm(sub.id);onClose();}} style={{flex:1,padding:14,borderRadius:14,background:"rgba(255,101,132,0.12)",border:`1px solid rgba(255,101,132,0.4)`,color:G.accent2,fontSize:15,fontWeight:700}}>Yes, Cancel</button>
        </div>
      </div>
    </Modal>
  );
}

// ─── TREND CHART ──────────────────────────────────────────────────────────────
function TrendChart({ subs }) {
  const W=340,H=150,PAD={t:16,r:10,b:28,l:38};
  const iW=W-PAD.l-PAD.r, iH=H-PAD.t-PAD.b;
  const totalByMonth=MONTHS.map((_,mi)=>subs.reduce((s,sub)=>s+(sub.trend[mi]||0),0));
  const maxV=Math.max(...totalByMonth)*1.1, minV=Math.min(...totalByMonth)*0.85;
  const range=maxV-minV;
  const xStep=iW/(MONTHS.length-1);
  const toY=v=>PAD.t+iH-((v-minV)/range)*iH;
  const linePts=totalByMonth.map((v,i)=>`${PAD.l+i*xStep},${toY(v)}`).join(" ");
  const areaPath=(()=>{
    const pts=totalByMonth.map((v,i)=>({x:PAD.l+i*xStep,y:toY(v)}));
    return pts.map((p,i)=>`${i===0?"M":"L"}${p.x},${p.y}`).join(" ")+` L${pts[pts.length-1].x},${PAD.t+iH} L${pts[0].x},${PAD.t+iH} Z`;
  })();
  const barW=iW/MONTHS.length*0.5;
  const catColors={entertainment:G.accent2,music:G.accent3,cloud:"#007aff",work:"#a259ff"};

  return (
    <div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:"100%",height:"auto"}}>
        <defs>
          <linearGradient id="ag" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={G.accent} stopOpacity="0.35"/>
            <stop offset="100%" stopColor={G.accent} stopOpacity="0.02"/>
          </linearGradient>
        </defs>
        {[0,0.25,0.5,0.75,1].map((f,i)=>{
          const yv=Math.round(maxV-f*(maxV-minV));
          return (
            <g key={i}>
              <line x1={PAD.l} y1={PAD.t+iH*f} x2={W-PAD.r} y2={PAD.t+iH*f} stroke={G.border} strokeWidth="1"/>
              <text x={PAD.l-4} y={PAD.t+iH*f} fontSize="8" fill={G.muted} textAnchor="end" dominantBaseline="middle">{yv>=1000?`${(yv/1000).toFixed(1)}k`:yv}</text>
            </g>
          );
        })}
        {totalByMonth.map((v,i)=>{
          const bh=((v-minV)/range)*iH;
          return <rect key={i} x={PAD.l+i*xStep-barW/2} y={PAD.t+iH-bh} width={barW} height={bh} rx="3" fill={i===MONTHS.length-1?G.accent:"rgba(108,99,255,0.2)"}/>;
        })}
        <path d={areaPath} fill="url(#ag)"/>
        <polyline points={linePts} fill="none" stroke={G.accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        {totalByMonth.map((v,i)=>(
          <circle key={i} cx={PAD.l+i*xStep} cy={toY(v)} r={i===MONTHS.length-1?5:2.5} fill={i===MONTHS.length-1?G.accent:G.surface2} stroke={G.accent} strokeWidth={i===MONTHS.length-1?0:1.5}/>
        ))}
        <circle cx={PAD.l+(MONTHS.length-1)*xStep} cy={toY(totalByMonth[11])} r="9" fill="none" stroke={G.accent} strokeOpacity="0.35" strokeWidth="2"/>
        {MONTHS.map((m,i)=>(
          <text key={m} x={PAD.l+i*xStep} y={H-4} fontSize="8" fill={i===MONTHS.length-1?G.accent:G.muted} textAnchor="middle" fontWeight={i===MONTHS.length-1?"bold":"normal"}>{m}</text>
        ))}
      </svg>
      <div style={{marginTop:12,display:"flex",flexDirection:"column",gap:7}}>
        {["entertainment","music","cloud","work"].map(cat=>{
          const total=subs.filter(s=>s.category===cat).reduce((a,s)=>a+s.price,0);
          const pct=Math.round((total/totalByMonth[11])*100)||0;
          if(!total)return null;
          return (
            <div key={cat}>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:G.muted,marginBottom:3}}>
                <span style={{textTransform:"capitalize"}}>{cat}</span>
                <span style={{color:G.text}}>₹{total} <span style={{color:G.muted}}>({pct}%)</span></span>
              </div>
              <div style={{height:5,borderRadius:10,background:G.border,overflow:"hidden"}}>
                <div style={{height:"100%",width:`${pct}%`,borderRadius:10,background:catColors[cat]}}/>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── HOME SCREEN ──────────────────────────────────────────────────────────────
function HomeScreen({ openModal }) {
  return (
    <div className="fade-up" style={{flex:1,overflowY:"auto"}}>
      <div style={{margin:16,padding:24,borderRadius:20,background:"linear-gradient(135deg,#1a1630,#13131a)",border:`1px solid rgba(108,99,255,0.2)`,position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:-40,right:-40,width:160,height:160,borderRadius:"50%",background:"radial-gradient(circle,rgba(108,99,255,0.18),transparent 70%)"}}/>
        <div style={{fontSize:11,color:G.muted,letterSpacing:1,textTransform:"uppercase",marginBottom:6}}>Total Balance</div>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:36,letterSpacing:-1,marginBottom:16}}>₹24,850<span style={{fontSize:20,opacity:0.5}}>.00</span></div>
        <div style={{fontSize:12,color:G.muted,display:"flex",alignItems:"center",gap:6}}>
          <span style={{background:"rgba(108,99,255,0.15)",border:`1px solid rgba(108,99,255,0.3)`,borderRadius:6,padding:"2px 8px",fontSize:11,color:G.accent,fontWeight:500}}>UPI</span>
          sr.kashyap@payvault
        </div>
      </div>
      <div style={{margin:"0 16px 16px",padding:"14px 16px",background:"rgba(247,151,30,0.08)",border:`1px solid rgba(247,151,30,0.25)`,borderRadius:14,display:"flex",alignItems:"center",gap:12}}>
        <div style={{fontSize:22}}>⚡</div>
        <div style={{flex:1}}>
          <div style={{fontSize:13,fontWeight:600,color:G.accent4}}>3 autopay renewals this week</div>
          <div style={{fontSize:11,color:G.muted,marginTop:2}}>Netflix, Spotify & iCloud · ₹843 total</div>
        </div>
      </div>
      <div style={{display:"flex",gap:10,padding:"0 16px 16px",overflowX:"auto"}}>
        {[{icon:"📤",label:"Send",action:()=>openModal("pay")},{icon:"📥",label:"Request",action:()=>openModal("request")},{icon:"⬛",label:"Scan QR",action:()=>openModal("scan")},{icon:"🔁",label:"Autopay",action:null},{icon:"📱",label:"Recharge",action:null},{icon:"⚡",label:"Utility",action:null}].map(qa=>(
          <div key={qa.label} onClick={qa.action} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:8,minWidth:70,padding:"14px 10px",background:G.surface,border:`1px solid ${G.border}`,borderRadius:16,cursor:"pointer",flexShrink:0}}>
            <div style={{fontSize:22}}>{qa.icon}</div>
            <div style={{fontSize:12,color:G.muted,whiteSpace:"nowrap"}}>{qa.label}</div>
          </div>
        ))}
      </div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"0 16px",marginBottom:12}}>
        <div style={{fontFamily:TNR,fontWeight:700,fontSize:16}}>Recent Transactions</div>
        <div style={{fontSize:13,color:G.accent,cursor:"pointer"}}>View All</div>
      </div>
      <div style={{padding:"0 16px",display:"flex",flexDirection:"column",gap:8,paddingBottom:28}}>
        {TRANSACTIONS.map(t=>(
          <div key={t.id} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",background:G.card,borderRadius:14,border:`1px solid ${G.border}`}}>
            <div style={{width:40,height:40,borderRadius:12,background:t.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{t.icon}</div>
            <div style={{flex:1}}>
              <div style={{fontSize:14,fontWeight:500}}>{t.name}</div>
              <div style={{fontSize:11,color:G.muted,marginTop:2}}>{t.date}</div>
            </div>
            <div style={{fontFamily:TNR,fontWeight:700,fontSize:15,color:t.amount<0?G.accent2:G.accent3}}>{t.amount<0?`–₹${Math.abs(t.amount)}`:`+₹${t.amount}`}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── SUBSCRIPTIONS SCREEN ─────────────────────────────────────────────────────
function SubscriptionsScreen({ subs, cancelled, onToggleAutopay, onCancel, openModal }) {
  const [activeTab, setActiveTab] = useState("all");
  const [selectedSub, setSelectedSub] = useState(null);
  const [cancelTarget, setCancelTarget] = useState(null);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const allSubsRef = useRef(null);
  const upcomingRef = useRef(null);
  const cancelledRef = useRef(null);

  const monthly = subs.reduce((s,sub)=>s+sub.price,0);
  const dueSoon = subs.filter(s=>s.daysLeft<=7).length;
  const upcoming = [...subs].sort((a,b)=>a.daysLeft-b.daysLeft).slice(0,4);
  const filtered = activeTab==="all"?subs:subs.filter(s=>s.category===activeTab);
  const daysColor = d=>d<=3?G.accent2:d<=7?G.accent4:d<=14?G.accent:G.muted;
  const scrollTo = ref=>ref.current?.scrollIntoView({behavior:"smooth",block:"start"});

  const requestCancel = (sub,e) => {
    e&&e.stopPropagation();
    setCancelTarget(sub);
    setShowCancelModal(true);
  };

  const confirmCancel = id => {
    onCancel(id);
    setSelectedSub(null);
    setTimeout(()=>cancelledRef.current?.scrollIntoView({behavior:"smooth"}),400);
  };

  // Keep selectedSub in sync if autopay toggled externally
  const currentSelected = selectedSub ? subs.find(s=>s.id===selectedSub.id)||selectedSub : null;

  return (
    <div className="fade-up" style={{flex:1,overflowY:"auto",padding:16}}>

      {/* KPI Cards */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:20}}>
        {[
          {val:`₹${monthly.toLocaleString()}`,label:"Monthly",  color:G.accent2, hint:"→ All Subs",  onClick:()=>scrollTo(allSubsRef)},
          {val:subs.length,                   label:"Active",   color:G.accent3, hint:"→ All Subs",  onClick:()=>scrollTo(allSubsRef)},
          {val:dueSoon,                        label:"Due Soon", color:G.accent4, hint:"→ Upcoming",  onClick:()=>scrollTo(upcomingRef)},
        ].map(c=>(
          <div key={c.label} onClick={c.onClick}
            onMouseEnter={e=>e.currentTarget.style.borderColor=c.color}
            onMouseLeave={e=>e.currentTarget.style.borderColor=G.border}
            style={{padding:"14px 10px",borderRadius:16,background:G.card,border:`1px solid ${G.border}`,textAlign:"center",cursor:"pointer",transition:"border-color 0.2s"}}>
            <div style={{fontFamily:TNR,fontWeight:800,fontSize:18,color:c.color}}>{c.val}</div>
            <div style={{fontSize:10,color:G.muted,marginTop:3,textTransform:"uppercase",letterSpacing:0.5}}>{c.label}</div>
            <div style={{fontSize:10,color:c.color,marginTop:4,opacity:0.8}}>{c.hint}</div>
          </div>
        ))}
      </div>

      {/* Trend Chart */}
      <div style={{background:G.card,border:`1px solid ${G.border}`,borderRadius:18,padding:16,marginBottom:16}}>
        <div style={{fontFamily:TNR,fontWeight:700,fontSize:15,marginBottom:4}}>📈 Spending Trend</div>
        <div style={{fontSize:11,color:G.muted,marginBottom:14}}>Last 12 months · Total subscription spend</div>
        <TrendChart subs={subs}/>
      </div>

      {/* Upcoming Payments */}
      <div ref={upcomingRef} style={{scrollMarginTop:16}}>
        <SectionTitle>⏰ Upcoming Payments</SectionTitle>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:20}}>
        {upcoming.map(sub=>(
          <div key={sub.id} style={{display:"flex",alignItems:"center",gap:10,padding:"12px 14px",background:G.card,borderRadius:14,border:`1px solid ${G.border}`}}>
            <div style={{minWidth:40,textAlign:"center",fontFamily:TNR,fontWeight:800,fontSize:18,color:daysColor(sub.daysLeft),lineHeight:1}}>
              {sub.daysLeft}<span style={{fontSize:10,color:G.muted,display:"block",fontWeight:400}}>days</span>
            </div>
            <div style={{width:1,height:36,background:G.border,flexShrink:0}}/>
            <div style={{fontSize:18,margin:"0 2px"}}>{sub.icon}</div>
            <div style={{flex:1}}>
              <div style={{fontSize:14,fontWeight:500}}>{sub.name}</div>
              <div style={{fontSize:11,color:G.muted,marginTop:2}}>{sub.nextDate} · {sub.autopay?"Auto":"Manual"}</div>
            </div>
            <div style={{fontFamily:TNR,fontWeight:700,fontSize:14}}>₹{sub.price}</div>
            <button onClick={e=>requestCancel(sub,e)} style={{padding:"5px 10px",borderRadius:10,background:"rgba(255,101,132,0.1)",border:`1px solid rgba(255,101,132,0.3)`,color:G.accent2,fontSize:11,fontWeight:600,whiteSpace:"nowrap"}}>Cancel</button>
          </div>
        ))}
      </div>

      {/* All Subscriptions */}
      <div ref={allSubsRef} style={{scrollMarginTop:16}}>
        <SectionTitle action="+ Add" onAction={()=>openModal("addSub")}>All Subscriptions</SectionTitle>
      </div>

      <div style={{display:"flex",gap:8,marginBottom:16,overflowX:"auto"}}>
        {CATEGORIES.map(cat=>(
          <div key={cat} onClick={()=>setActiveTab(cat)} style={{padding:"7px 16px",borderRadius:20,fontSize:13,fontWeight:500,cursor:"pointer",whiteSpace:"nowrap",flexShrink:0,background:activeTab===cat?G.accent:"transparent",border:`1px solid ${activeTab===cat?G.accent:G.border}`,color:activeTab===cat?"#fff":G.muted,transition:"all 0.2s"}}>
            {cat==="all"?`All (${subs.length})`:cat.charAt(0).toUpperCase()+cat.slice(1)}
          </div>
        ))}
      </div>

      <div style={{display:"flex",flexDirection:"column",gap:12,marginBottom:28}}>
        {filtered.map(sub=>(
          <div key={sub.id} onClick={()=>setSelectedSub(sub)} className="hover-card" style={{background:G.card,border:`1px solid ${G.border}`,borderRadius:18,padding:16,cursor:"pointer",transition:"border-color 0.2s"}}>
            <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",marginBottom:12}}>
              <div style={{display:"flex",alignItems:"center",gap:12}}>
                <div style={{width:44,height:44,borderRadius:12,background:sub.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>{sub.icon}</div>
                <div>
                  <div style={{fontFamily:TNR,fontWeight:700,fontSize:15}}>{sub.name}</div>
                  <div style={{fontSize:11,color:G.muted,marginTop:3}}>{sub.plan}</div>
                </div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{fontFamily:TNR,fontWeight:800,fontSize:17}}>₹{sub.price}</div>
                <div style={{fontSize:11,color:G.muted}}>/{sub.cycle}</div>
              </div>
            </div>
            <div style={{display:"flex",gap:8,marginBottom:12,alignItems:"center",flexWrap:"wrap"}}>
              <span style={{padding:"4px 10px",borderRadius:20,fontSize:11,fontWeight:500,background:sub.autopay?"rgba(67,233,123,0.1)":"rgba(247,151,30,0.1)",color:sub.autopay?G.accent3:G.accent4,border:`1px solid ${sub.autopay?"rgba(67,233,123,0.2)":"rgba(247,151,30,0.2)"}`}}>
                {sub.autopay?"✓ Autopay ON":"⚠ Manual Pay"}
              </span>
              <span style={{padding:"4px 10px",borderRadius:20,fontSize:11,fontWeight:500,background:"rgba(108,99,255,0.1)",color:"#a89fff",border:"1px solid rgba(108,99,255,0.2)"}}>📅 {sub.nextDate}</span>
              <button onClick={e=>requestCancel(sub,e)} style={{marginLeft:"auto",padding:"5px 14px",borderRadius:20,background:"rgba(255,101,132,0.1)",border:`1px solid rgba(255,101,132,0.3)`,color:G.accent2,fontSize:11,fontWeight:700}}>Cancel</button>
            </div>
            <div style={{fontSize:11,color:G.muted,display:"flex",justifyContent:"space-between",marginBottom:6}}>
              <span>{sub.usageLabel}</span><span>{sub.usageVal}</span>
            </div>
            <UsageBar pct={sub.usagePct} color={`linear-gradient(90deg,${sub.color},${sub.color}88)`}/>
          </div>
        ))}
      </div>

      {/* Cancelled Section */}
      {cancelled.length>0 && (
        <div ref={cancelledRef} style={{scrollMarginTop:16,paddingBottom:24}}>
          <SectionTitle>{`🚫 Cancelled Subscriptions (${cancelled.length})`}</SectionTitle>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {cancelled.map(sub=>(
              <div key={sub.id} style={{background:G.card,border:`1px solid rgba(255,101,132,0.2)`,borderRadius:18,padding:16,opacity:0.75}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                  <div style={{display:"flex",alignItems:"center",gap:12}}>
                    <div style={{width:44,height:44,borderRadius:12,background:sub.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,filter:"grayscale(70%)"}}>{sub.icon}</div>
                    <div>
                      <div style={{fontFamily:TNR,fontWeight:700,fontSize:15,color:G.muted}}>{sub.name}</div>
                      <div style={{fontSize:11,color:G.muted,marginTop:3}}>{sub.plan}</div>
                    </div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{fontFamily:TNR,fontWeight:700,fontSize:15,color:G.muted,textDecoration:"line-through"}}>₹{sub.price}</div>
                    <div style={{fontSize:10,color:G.muted}}>Cancelled</div>
                  </div>
                </div>
                <div style={{marginTop:10,fontSize:11,color:G.muted,background:"rgba(255,101,132,0.06)",borderRadius:8,padding:"6px 10px"}}>
                  Cancelled on {sub.cancelledOn} · You save ₹{sub.price}/month
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Sub Detail Modal */}
      <Modal open={!!currentSelected} onClose={()=>setSelectedSub(null)}>
        {currentSelected && (
          <SubDetailSheet
            sub={currentSelected}
            onClose={()=>setSelectedSub(null)}
            onToggleAutopay={v=>onToggleAutopay(currentSelected.id,v)}
            onCancel={sub=>{setSelectedSub(null);requestCancel(sub);}}
          />
        )}
      </Modal>

      <CancelConfirmModal open={showCancelModal} sub={cancelTarget} onConfirm={confirmCancel} onClose={()=>{setShowCancelModal(false);setCancelTarget(null);}}/>
    </div>
  );
}

function SubDetailSheet({ sub, onClose, onToggleAutopay, onCancel }) {
  const [reminder,setReminder] = useState(true);
  return (
    <>
      <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:20}}>
        <div style={{width:54,height:54,borderRadius:14,background:sub.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:28}}>{sub.icon}</div>
        <div>
          <div style={{fontFamily:TNR,fontWeight:800,fontSize:20}}>{sub.name}</div>
          <div style={{fontSize:13,color:G.muted}}>{sub.plan}</div>
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:20}}>
        {[{val:`₹${sub.price}`,label:"Monthly"},{val:sub.nextDate,label:"Next Date"},{val:sub.usagePct+"%",label:"Usage",color:G.accent3},{val:"Active",label:"Status",color:G.accent3}].map(c=>(
          <div key={c.label} style={{padding:"14px 12px",borderRadius:14,background:G.surface2,textAlign:"center"}}>
            <div style={{fontFamily:TNR,fontWeight:800,fontSize:17,color:c.color||G.text}}>{c.val}</div>
            <div style={{fontSize:10,color:G.muted,marginTop:4,textTransform:"uppercase"}}>{c.label}</div>
          </div>
        ))}
      </div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 0",borderBottom:`1px solid ${G.border}`}}>
        <div>
          <div style={{fontSize:14,fontWeight:500}}>Autopay</div>
          <div style={{fontSize:12,color:G.muted,marginTop:2}}>Auto-deduct on due date</div>
        </div>
        <Toggle on={sub.autopay} onChange={v=>onToggleAutopay(v)}/>
      </div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 0",borderBottom:`1px solid ${G.border}`}}>
        <div>
          <div style={{fontSize:14,fontWeight:500}}>Reminder Alert</div>
          <div style={{fontSize:12,color:G.muted,marginTop:2}}>Notify 2 days before</div>
        </div>
        <Toggle on={reminder} onChange={setReminder}/>
      </div>
      <button onClick={()=>onCancel(sub)} style={{width:"100%",padding:14,borderRadius:14,marginTop:16,background:"rgba(255,0,80,0.1)",color:G.accent2,border:`1px solid rgba(255,101,132,0.3)`,fontFamily:TNR,fontWeight:700,fontSize:15}}>Cancel Subscription</button>
    </>
  );
}

// ─── WALLET SCREEN ────────────────────────────────────────────────────────────
function WalletScreen({ subs, onToggleAutopay, onCancel }) {
  const [confirmSub, setConfirmSub] = useState(null);
  return (
    <div className="fade-up" style={{flex:1,overflowY:"auto",padding:16}}>
      <div style={{background:"linear-gradient(135deg,#1a1630,#13131a)",border:"1px solid rgba(108,99,255,0.2)",borderRadius:20,padding:"28px 24px",textAlign:"center",marginBottom:20}}>
        <div style={{fontSize:11,color:G.muted,textTransform:"uppercase",letterSpacing:1}}>Wallet Balance</div>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:42,letterSpacing:-2,margin:"8px 0 16px"}}>₹4,850</div>
        <div style={{display:"flex",gap:10,justifyContent:"center"}}>
          <button style={{padding:"10px 20px",borderRadius:12,fontSize:13,fontWeight:600,background:G.accent,color:"#fff",border:"none"}}>+ Add Money</button>
          <button style={{padding:"10px 20px",borderRadius:12,fontSize:13,fontWeight:600,background:G.surface2,color:G.text,border:`1px solid ${G.border}`}}>Withdraw</button>
        </div>
      </div>

      <SectionTitle>Linked Accounts</SectionTitle>
      {[{icon:"🏦",name:"HDFC Bank",acc:"•••• 4821",primary:true},{icon:"🏛️",name:"SBI",acc:"•••• 0932"},{icon:"💳",name:"Axis Bank",acc:"•••• 7714"}].map(b=>(
        <div key={b.name} style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px",background:G.card,borderRadius:16,border:`1px solid ${G.border}`,marginBottom:8}}>
          <div style={{width:40,height:40,borderRadius:10,background:"#1a1a2e",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>{b.icon}</div>
          <div style={{flex:1}}>
            <div style={{fontSize:14,fontWeight:500}}>{b.name}</div>
            <div style={{fontSize:12,color:G.muted}}>{b.acc}</div>
          </div>
          {b.primary&&<span style={{fontSize:11,background:"rgba(108,99,255,0.1)",color:G.accent,padding:"3px 8px",borderRadius:6,border:`1px solid rgba(108,99,255,0.2)`}}>Primary</span>}
        </div>
      ))}

      <div style={{marginTop:20}}>
        <SectionTitle>Autopay Mandates</SectionTitle>
        <div style={{fontSize:11,color:G.muted,marginBottom:12,marginTop:-8}}>Changes here sync with Subscriptions page</div>
        <div style={{display:"flex",flexDirection:"column",gap:8,paddingBottom:24}}>
          {subs.map(sub=>(
            <div key={sub.id} style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px",background:G.card,borderRadius:14,border:`1px solid ${sub.autopay?"rgba(67,233,123,0.2)":G.border}`,transition:"border-color 0.3s"}}>
              <div style={{fontSize:22}}>{sub.icon}</div>
              <div style={{flex:1}}>
                <div style={{fontSize:14,fontWeight:500}}>{sub.name}</div>
                <div style={{fontSize:11,marginTop:2,color:sub.autopay?G.accent3:G.accent4,fontWeight:500}}>
                  {sub.autopay?"✓ Autopay ON — ":"⚠ Autopay OFF — "}
                  <span style={{color:G.muted,fontWeight:400}}>₹{sub.price}/month</span>
                </div>
              </div>
              <Toggle on={sub.autopay} onChange={v=>{
                if(!v){ setConfirmSub(sub); }
                else { onToggleAutopay(sub.id,true); }
              }}/>
            </div>
          ))}
        </div>
      </div>

      <CancelConfirmModal
        open={!!confirmSub}
        sub={confirmSub}
        onConfirm={id=>{ onCancel(id); setConfirmSub(null); }}
        onClose={()=>setConfirmSub(null)}
      />
    </div>
  );
}

// ─── PROFILE SCREEN ───────────────────────────────────────────────────────────
function ProfileScreen({ setScreen }) {
  const [appLock,setAppLock] = useState(true);
  const [fraudAlerts,setFraudAlerts] = useState(true);
  const [modal,setModal] = useState(null);

  return (
    <div className="fade-up" style={{flex:1,overflowY:"auto",padding:16}}>
      {/* Avatar */}
      <div style={{textAlign:"center",padding:"24px 0 20px"}}>
        <div style={{width:80,height:80,borderRadius:"50%",background:`linear-gradient(135deg,${G.accent},${G.accent2})`,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:TNR,fontWeight:800,fontSize:24,margin:"0 auto 12px"}}>{USER.initials}</div>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:22}}>{USER.name}</div>
        <div style={{fontSize:13,color:G.muted,marginTop:4}}>{USER.email}</div>
        <div style={{fontSize:12,color:G.muted,marginTop:2}}>sr.kashyap@payvault</div>
      </div>

      {/* Account */}
      <div style={{marginBottom:20}}>
        <div style={{fontSize:12,color:G.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:8,paddingLeft:4}}>Account</div>
        {[
          {icon:"👤",label:"Edit Profile",    onClick:()=>setModal("editProfile")},
          {icon:"🔐",label:"UPI PIN",         onClick:()=>setModal("upiPin")},
          {icon:"📱",label:"Linked Devices",  onClick:()=>setModal("devices")},
        ].map(item=>(
          <div key={item.label} onClick={item.onClick} style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px",background:G.card,borderRadius:14,marginBottom:6,cursor:"pointer",border:`1px solid ${G.border}`}}>
            <div style={{fontSize:18,width:32,textAlign:"center"}}>{item.icon}</div>
            <div style={{flex:1,fontSize:14}}>{item.label}</div>
            <div style={{fontSize:14,color:G.muted}}>›</div>
          </div>
        ))}
      </div>

      {/* Payments */}
      <div style={{marginBottom:20}}>
        <div style={{fontSize:12,color:G.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:8,paddingLeft:4}}>Payments</div>
        {[
          {icon:"🏦",label:"Bank Accounts",      onClick:()=>setModal("bankAccounts")},
          {icon:"🔁",label:"Manage Autopay",     onClick:()=>setScreen("wallet")},
          {icon:"📄",label:"Transaction History", onClick:()=>setModal("txnHistory")},
        ].map(item=>(
          <div key={item.label} onClick={item.onClick} style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px",background:G.card,borderRadius:14,marginBottom:6,cursor:"pointer",border:`1px solid ${G.border}`}}>
            <div style={{fontSize:18,width:32,textAlign:"center"}}>{item.icon}</div>
            <div style={{flex:1,fontSize:14}}>{item.label}</div>
            <div style={{fontSize:14,color:G.muted}}>›</div>
          </div>
        ))}
      </div>

      {/* Security */}
      <div style={{marginBottom:20}}>
        <div style={{fontSize:12,color:G.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:8,paddingLeft:4}}>Security</div>
        <div style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px",background:G.card,borderRadius:14,marginBottom:6,border:`1px solid ${G.border}`}}>
          <div style={{fontSize:18,width:32,textAlign:"center"}}>🔒</div>
          <div style={{flex:1,fontSize:14}}>App Lock</div>
          <Toggle on={appLock} onChange={setAppLock}/>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px",background:G.card,borderRadius:14,marginBottom:6,border:`1px solid ${G.border}`}}>
          <div style={{fontSize:18,width:32,textAlign:"center"}}>🛡️</div>
          <div style={{flex:1,fontSize:14}}>Fraud Alerts</div>
          <Toggle on={fraudAlerts} onChange={setFraudAlerts}/>
        </div>
        <div onClick={()=>setModal("reportFraud")} style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px",background:G.card,borderRadius:14,marginBottom:6,cursor:"pointer",border:`1px solid ${G.border}`}}>
          <div style={{fontSize:18,width:32,textAlign:"center"}}>🆘</div>
          <div style={{flex:1,fontSize:14}}>Report Fraud</div>
          <div style={{fontSize:14,color:G.muted}}>›</div>
        </div>
      </div>

      {/* More */}
      <div style={{marginBottom:24}}>
        <div style={{fontSize:12,color:G.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:8,paddingLeft:4}}>More</div>
        {[
          {icon:"❓",label:"Help & Support",   onClick:()=>setModal("help")},
          {icon:"⭐",label:"Rate PayVault",     onClick:()=>setModal("rate")},
          {icon:"🚪",label:"Logout",            onClick:()=>setModal("logout"),red:true},
        ].map(item=>(
          <div key={item.label} onClick={item.onClick} style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px",background:G.card,borderRadius:14,marginBottom:6,cursor:"pointer",border:`1px solid ${item.red?"rgba(255,101,132,0.25)":G.border}`}}>
            <div style={{fontSize:18,width:32,textAlign:"center"}}>{item.icon}</div>
            <div style={{flex:1,fontSize:14,color:item.red?G.accent2:G.text}}>{item.label}</div>
            <div style={{fontSize:14,color:item.red?G.accent2:G.muted}}>›</div>
          </div>
        ))}
      </div>

      {/* Profile Modals */}
      <ProfileModals modal={modal} onClose={()=>setModal(null)}/>
    </div>
  );
}

// ─── PROFILE MODALS ───────────────────────────────────────────────────────────
function ProfileModals({ modal, onClose }) {
  const InfoRow = ({label,val})=>(
    <div style={{display:"flex",justifyContent:"space-between",padding:"11px 0",borderBottom:`1px solid ${G.border}`}}>
      <span style={{fontSize:13,color:G.muted}}>{label}</span>
      <span style={{fontSize:13,fontWeight:500}}>{val}</span>
    </div>
  );

  const panels = {
    editProfile: (
      <>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:16}}>Edit Profile</div>
        {[["Full Name","SR Kashyap"],["Phone","•••• •••• 4291"],["Email",USER.email],["UPI ID","sr.kashyap@payvault"],["Date of Birth","12 Mar 1992"]].map(([l,v])=>(
          <div key={l} style={{marginBottom:12}}>
            <div style={{fontSize:11,color:G.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:5}}>{l}</div>
            <input defaultValue={v} style={{width:"100%",background:G.card,border:`1px solid ${G.border}`,borderRadius:12,padding:"11px 14px",color:G.text,fontSize:14}}/>
          </div>
        ))}
        <button onClick={onClose} style={{width:"100%",padding:14,borderRadius:14,background:`linear-gradient(135deg,${G.accent},#9b8cff)`,border:"none",color:"#fff",fontFamily:TNR,fontWeight:700,fontSize:15,marginTop:8}}>Save Changes</button>
      </>
    ),
    upiPin: (
      <>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:6}}>UPI PIN</div>
        <div style={{fontSize:13,color:G.muted,marginBottom:20}}>Change your 6-digit UPI PIN</div>
        <div style={{marginBottom:12}}>
          <div style={{fontSize:11,color:G.muted,textTransform:"uppercase",marginBottom:5}}>Current PIN</div>
          <input type="password" maxLength={6} placeholder="••••••" style={{width:"100%",background:G.card,border:`1px solid ${G.border}`,borderRadius:12,padding:"11px 14px",color:G.text,fontSize:18,letterSpacing:6}}/>
        </div>
        <div style={{marginBottom:12}}>
          <div style={{fontSize:11,color:G.muted,textTransform:"uppercase",marginBottom:5}}>New PIN</div>
          <input type="password" maxLength={6} placeholder="••••••" style={{width:"100%",background:G.card,border:`1px solid ${G.border}`,borderRadius:12,padding:"11px 14px",color:G.text,fontSize:18,letterSpacing:6}}/>
        </div>
        <div style={{marginBottom:20}}>
          <div style={{fontSize:11,color:G.muted,textTransform:"uppercase",marginBottom:5}}>Confirm New PIN</div>
          <input type="password" maxLength={6} placeholder="••••••" style={{width:"100%",background:G.card,border:`1px solid ${G.border}`,borderRadius:12,padding:"11px 14px",color:G.text,fontSize:18,letterSpacing:6}}/>
        </div>
        <button onClick={onClose} style={{width:"100%",padding:14,borderRadius:14,background:`linear-gradient(135deg,${G.accent},#9b8cff)`,border:"none",color:"#fff",fontFamily:TNR,fontWeight:700,fontSize:15}}>Update PIN</button>
      </>
    ),
    devices: (
      <>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:16}}>Linked Devices</div>
        {[{icon:"📱",name:"Samsung Galaxy S24",loc:"Mysuru, Karnataka",active:true},{icon:"💻",name:"Windows Laptop",loc:"Last active 2 days ago",active:false},{icon:"📱",name:"iPad Pro",loc:"Last active 5 days ago",active:false}].map((d,i)=>(
          <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"14px",background:G.card,borderRadius:14,border:`1px solid ${d.active?"rgba(67,233,123,0.3)":G.border}`,marginBottom:8}}>
            <div style={{fontSize:24}}>{d.icon}</div>
            <div style={{flex:1}}>
              <div style={{fontSize:14,fontWeight:500}}>{d.name}</div>
              <div style={{fontSize:11,color:d.active?G.accent3:G.muted,marginTop:2}}>{d.active?"● Active now":d.loc}</div>
            </div>
            {!d.active&&<button style={{padding:"5px 10px",borderRadius:8,background:"rgba(255,101,132,0.1)",border:`1px solid rgba(255,101,132,0.3)`,color:G.accent2,fontSize:11}}>Remove</button>}
          </div>
        ))}
      </>
    ),
    bankAccounts: (
      <>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:16}}>Bank Accounts</div>
        {[{icon:"🏦",name:"HDFC Bank",acc:"•••• •••• •••• 4821",ifsc:"HDFC0001234",type:"Savings",primary:true},{icon:"🏛️",name:"SBI",acc:"•••• •••• •••• 0932",ifsc:"SBIN0005678",type:"Savings"},{icon:"💳",name:"Axis Bank",acc:"•••• •••• •••• 7714",ifsc:"UTIB0002345",type:"Current"}].map((b,i)=>(
          <div key={i} style={{background:G.card,border:`1px solid ${b.primary?"rgba(108,99,255,0.3)":G.border}`,borderRadius:16,padding:14,marginBottom:10}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
              <div style={{width:38,height:38,borderRadius:10,background:"#1a1a2e",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>{b.icon}</div>
              <div style={{flex:1}}>
                <div style={{fontSize:14,fontWeight:600}}>{b.name}</div>
                <div style={{fontSize:11,color:G.muted}}>{b.type}</div>
              </div>
              {b.primary&&<span style={{fontSize:10,background:"rgba(108,99,255,0.1)",color:G.accent,padding:"3px 8px",borderRadius:6,border:`1px solid rgba(108,99,255,0.2)`}}>Primary</span>}
            </div>
            <InfoRow label="Account No." val={b.acc}/>
            <InfoRow label="IFSC Code" val={b.ifsc}/>
          </div>
        ))}
        <button onClick={onClose} style={{width:"100%",padding:13,borderRadius:14,background:`linear-gradient(135deg,${G.accent},#9b8cff)`,border:"none",color:"#fff",fontFamily:TNR,fontWeight:700,fontSize:14,marginTop:6}}>+ Link New Account</button>
      </>
    ),
    txnHistory: (
      <>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:16}}>Transaction History</div>
        {TRANSACTIONS.concat([
          {id:6,name:"Figma Autopay",   date:"28 Apr · Auto", amount:-540, icon:"🎨", bg:"rgba(162,89,255,0.1)"},
          {id:7,name:"Received from Raj",date:"25 Apr · UPI", amount:5000, icon:"💸", bg:"rgba(67,233,123,0.1)"},
          {id:8,name:"Notion Pro",       date:"22 Apr · Auto", amount:-325, icon:"📝", bg:"rgba(255,255,255,0.06)"},
        ]).map(t=>(
          <div key={t.id} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",background:G.card,borderRadius:14,border:`1px solid ${G.border}`,marginBottom:8}}>
            <div style={{width:38,height:38,borderRadius:10,background:t.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>{t.icon}</div>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:500}}>{t.name}</div>
              <div style={{fontSize:11,color:G.muted,marginTop:1}}>{t.date}</div>
            </div>
            <div style={{fontFamily:TNR,fontWeight:700,fontSize:14,color:t.amount<0?G.accent2:G.accent3}}>{t.amount<0?`–₹${Math.abs(t.amount)}`:`+₹${t.amount}`}</div>
          </div>
        ))}
      </>
    ),
    reportFraud: (
      <>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:6}}>Report Fraud</div>
        <div style={{fontSize:13,color:G.muted,marginBottom:20}}>We'll investigate and freeze suspicious activity immediately</div>
        <div style={{marginBottom:12}}>
          <div style={{fontSize:11,color:G.muted,textTransform:"uppercase",marginBottom:5}}>Type of Fraud</div>
          <select style={{width:"100%",background:G.card,border:`1px solid ${G.border}`,borderRadius:12,padding:"11px 14px",color:G.text,fontSize:14}}>
            <option>Unauthorised Transaction</option>
            <option>Phishing / Fake Call</option>
            <option>SIM Swap</option>
            <option>Other</option>
          </select>
        </div>
        <div style={{marginBottom:20}}>
          <div style={{fontSize:11,color:G.muted,textTransform:"uppercase",marginBottom:5}}>Description</div>
          <textarea placeholder="Describe what happened..." style={{width:"100%",background:G.card,border:`1px solid ${G.border}`,borderRadius:12,padding:"11px 14px",color:G.text,fontSize:14,minHeight:90,resize:"none",fontFamily:TNR}}/>
        </div>
        <button onClick={onClose} style={{width:"100%",padding:14,borderRadius:14,background:"rgba(255,101,132,0.15)",border:`1px solid rgba(255,101,132,0.4)`,color:G.accent2,fontFamily:TNR,fontWeight:700,fontSize:15}}>Submit Report</button>
      </>
    ),
    help: (
      <>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:16}}>Help & Support</div>
        {[
          {q:"How do I set up autopay?",    a:"Go to Subscriptions → tap any subscription → toggle Autopay ON. It will auto-deduct on the due date."},
          {q:"How do I cancel a subscription?", a:"Go to Subscriptions → tap Cancel on any card. You'll be asked to confirm before it's removed."},
          {q:"Is my data safe?",            a:"Yes. PayVault uses 256-bit encryption and never shares your financial data with third parties."},
          {q:"How do I add a bank account?",a:"Go to Profile → Bank Accounts → Link New Account. You'll need your account number and IFSC code."},
          {q:"Who do I contact for disputes?",a:"Email support@payvault.in or call 1800-XXX-XXXX (toll free, 9am–9pm)"},
        ].map((item,i)=>(
          <div key={i} style={{background:G.card,border:`1px solid ${G.border}`,borderRadius:14,padding:14,marginBottom:8}}>
            <div style={{fontSize:13,fontWeight:600,marginBottom:6}}>Q: {item.q}</div>
            <div style={{fontSize:12,color:G.muted,lineHeight:1.6}}>{item.a}</div>
          </div>
        ))}
      </>
    ),
    rate: (
      <>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:6,textAlign:"center"}}>Rate PayVault</div>
        <div style={{fontSize:13,color:G.muted,marginBottom:20,textAlign:"center"}}>Your feedback helps us improve</div>
        <div style={{display:"flex",justifyContent:"center",gap:12,fontSize:36,marginBottom:20}}>
          {["⭐","⭐","⭐","⭐","⭐"].map((_,i)=><span key={i} style={{cursor:"pointer"}}>{_}</span>)}
        </div>
        <div style={{marginBottom:16}}>
          <textarea placeholder="Tell us what you love or what we can improve..." style={{width:"100%",background:G.card,border:`1px solid ${G.border}`,borderRadius:12,padding:"11px 14px",color:G.text,fontSize:14,minHeight:80,resize:"none",fontFamily:TNR}}/>
        </div>
        <button onClick={onClose} style={{width:"100%",padding:14,borderRadius:14,background:`linear-gradient(135deg,${G.accent},#9b8cff)`,border:"none",color:"#fff",fontFamily:TNR,fontWeight:700,fontSize:15}}>Submit Rating</button>
      </>
    ),
    logout: (
      <>
        <div style={{textAlign:"center",padding:"8px 0 16px"}}>
          <div style={{fontSize:48,marginBottom:12}}>🚪</div>
          <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:8}}>Log Out?</div>
          <div style={{fontSize:13,color:G.muted,marginBottom:24}}>You'll need to log in again to access your account</div>
          <div style={{display:"flex",gap:12}}>
            <button onClick={onClose} style={{flex:1,padding:14,borderRadius:14,background:G.surface2,border:`1px solid ${G.border}`,color:G.text,fontSize:15,fontWeight:600}}>Cancel</button>
            <button onClick={onClose} style={{flex:1,padding:14,borderRadius:14,background:"rgba(255,101,132,0.12)",border:`1px solid rgba(255,101,132,0.4)`,color:G.accent2,fontSize:15,fontWeight:700}}>Log Out</button>
          </div>
        </div>
      </>
    ),
  };

  return (
    <Modal open={!!modal} onClose={onClose}>
      {modal && panels[modal]}
    </Modal>
  );
}

// ─── PAY MODAL ────────────────────────────────────────────────────────────────
function PayModal({ open, onClose, onSuccess }) {
  const [amt,setAmt]=useState(""); const [to,setTo]=useState("");
  const press=k=>{if(k==="del"){setAmt(a=>a.slice(0,-1));return;}if(k==="."&&amt.includes("."))return;if(amt.length>=8)return;setAmt(a=>a+k);};
  const pay=()=>{if(!to||!amt)return;onSuccess(`₹${amt} sent to ${to}`);setAmt("");setTo("");onClose();};
  return (
    <Modal open={open} onClose={onClose}>
      <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:12}}>Send Money</div>
      <input value={to} onChange={e=>setTo(e.target.value)} placeholder="name@upi or phone number" style={{width:"100%",background:G.card,border:`1px solid ${G.border}`,borderRadius:12,padding:"12px 14px",color:G.text,fontSize:14,marginBottom:16}}/>
      <div style={{textAlign:"center",fontFamily:TNR,fontWeight:800,fontSize:42,letterSpacing:-2,borderBottom:`1px solid ${G.border}`,paddingBottom:16,marginBottom:8}}>₹{amt||"0"}</div>
      <div style={{textAlign:"center",fontSize:12,color:G.muted,marginBottom:16}}>Enter amount</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10}}>
        {["1","2","3","4","5","6","7","8","9",".","0","del"].map(k=>(
          <button key={k} onClick={()=>press(k)} style={{padding:16,fontFamily:TNR,fontWeight:700,fontSize:k==="del"?14:20,background:G.card,border:`1px solid ${G.border}`,borderRadius:14,color:G.text}}>{k==="del"?"⌫":k}</button>
        ))}
        <button onClick={pay} style={{gridColumn:"1/-1",padding:16,borderRadius:14,fontFamily:TNR,fontWeight:700,fontSize:16,background:`linear-gradient(135deg,${G.accent},#9b8cff)`,border:"none",color:"#fff"}}>Pay Now</button>
      </div>
    </Modal>
  );
}

function RequestModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose}>
      <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:6}}>Request Money</div>
      <div style={{fontSize:13,color:G.muted,marginBottom:20}}>Request from UPI ID</div>
      {["From (UPI/phone)","Amount (₹)","Note"].map((pl,i)=>(
        <input key={pl} type={i===1?"number":"text"} placeholder={pl} style={{width:"100%",background:G.card,border:`1px solid ${G.border}`,borderRadius:12,padding:"12px 14px",color:G.text,fontSize:14,marginBottom:12}}/>
      ))}
      <button onClick={onClose} style={{width:"100%",padding:16,borderRadius:14,background:`linear-gradient(135deg,${G.accent},#9b8cff)`,border:"none",color:"#fff",fontFamily:TNR,fontWeight:700,fontSize:16}}>Send Request</button>
    </Modal>
  );
}

function AddSubModal({ open, onClose }) {
  const [autopay,setAutopay]=useState(true);
  return (
    <Modal open={open} onClose={onClose}>
      <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:6}}>Add Subscription</div>
      <div style={{fontSize:13,color:G.muted,marginBottom:20}}>Track a new recurring payment</div>
      {[["Service Name","text","e.g. Disney+, ChatGPT"],["Amount (₹)","number","0.00"],["Next Due Date","date",""]].map(([label,type,ph])=>(
        <div key={label} style={{marginBottom:14}}>
          <div style={{fontSize:11,color:G.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:6}}>{label}</div>
          <input type={type} placeholder={ph} style={{width:"100%",background:G.card,border:`1px solid ${G.border}`,borderRadius:12,padding:"12px 14px",color:G.text,fontSize:14}}/>
        </div>
      ))}
      <div style={{marginBottom:14}}>
        <div style={{fontSize:11,color:G.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:6}}>Billing Cycle</div>
        <select style={{width:"100%",background:G.card,border:`1px solid ${G.border}`,borderRadius:12,padding:"12px 14px",color:G.text,fontSize:14}}>
          <option>Monthly</option><option>Quarterly</option><option>Yearly</option>
        </select>
      </div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 0",borderBottom:`1px solid ${G.border}`,marginBottom:16}}>
        <div>
          <div style={{fontSize:14,fontWeight:500}}>Enable Autopay</div>
          <div style={{fontSize:12,color:G.muted,marginTop:2}}>Auto-deduct from linked account</div>
        </div>
        <Toggle on={autopay} onChange={setAutopay}/>
      </div>
      <button onClick={onClose} style={{width:"100%",padding:16,borderRadius:14,background:`linear-gradient(135deg,${G.accent},#9b8cff)`,border:"none",color:"#fff",fontFamily:TNR,fontWeight:700,fontSize:16}}>Add Subscription</button>
    </Modal>
  );
}

function SuccessModal({ open, message, onClose }) {
  return (
    <Modal open={open} onClose={onClose}>
      <div style={{textAlign:"center",padding:"20px 0"}}>
        <div className="pop-in" style={{width:80,height:80,borderRadius:"50%",background:"rgba(67,233,123,0.15)",border:`2px solid ${G.accent3}`,margin:"0 auto 16px",display:"flex",alignItems:"center",justifyContent:"center",fontSize:36}}>✓</div>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:22,marginBottom:8}}>Payment Successful!</div>
        <div style={{fontSize:14,color:G.muted}}>{message}</div>
      </div>
      <button onClick={onClose} style={{width:"100%",padding:16,borderRadius:14,background:`linear-gradient(135deg,${G.accent},#9b8cff)`,border:"none",color:"#fff",fontFamily:TNR,fontWeight:700,fontSize:16,marginTop:16}}>Done</button>
    </Modal>
  );
}

function ScanModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose}>
      <div style={{textAlign:"center"}}>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:6}}>Scan & Pay</div>
        <div style={{fontSize:13,color:G.muted,marginBottom:16}}>Point camera at any QR code</div>
        <div style={{width:200,height:200,margin:"0 auto 16px",borderRadius:20,background:G.card,border:`2px solid ${G.accent}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:60}}>⬛</div>
        <div style={{fontSize:13,color:G.muted,marginBottom:16}}>Camera access required</div>
        <button onClick={onClose} style={{width:"100%",padding:16,borderRadius:14,background:`linear-gradient(135deg,${G.accent},#9b8cff)`,border:"none",color:"#fff",fontFamily:TNR,fontWeight:700,fontSize:16}}>Enable Camera</button>
      </div>
    </Modal>
  );
}

// ─── ROOT APP — all shared state lives here ───────────────────────────────────
const TABS = [
  {id:"home",          label:"Home",          icon:"🏠"},
  {id:"subscriptions", label:"Subscriptions", icon:"🔁"},
  {id:"wallet",        label:"Wallet",        icon:"👛"},
  {id:"profile",       label:"Profile",       icon:"👤"},
];

export default function PayVault() {
  const [screen,   setScreen]    = useState("home");
  const [modal,    setModal]     = useState(null);
  const [successMsg,setSuccessMsg]=useState("");

  // ── Global subscription state (persists for entire session) ──
  const [subs,     setSubs]      = useState(INITIAL_SUBS);
  const [cancelled,setCancelled] = useState([]);

  // Toggle autopay — shared between Subscriptions and Wallet
  const handleToggleAutopay = (id, val) => {
    setSubs(prev => prev.map(s => s.id===id ? {...s, autopay:val} : s));
  };

  // Cancel subscription — removes from active, adds to cancelled list
  const handleCancel = id => {
    const sub = subs.find(s=>s.id===id);
    if (!sub) return;
    setSubs(prev=>prev.filter(s=>s.id!==id));
    setCancelled(prev=>[{...sub, cancelledOn:"May 6, 2026"}, ...prev]);
  };

  return (
    <>
      <style>{css}</style>
      <div className="pv-shell">

        {/* TOP BAR */}
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"18px 20px 12px",position:"sticky",top:0,zIndex:100,background:"rgba(10,10,15,0.95)",backdropFilter:"blur(12px)",borderBottom:`1px solid ${G.border}`}}>
          <div style={{fontFamily:TNR,fontWeight:800,fontSize:22,background:"linear-gradient(135deg,#6c63ff,#ff6584)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>PayVault</div>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <div style={{position:"relative",cursor:"pointer",fontSize:18,color:G.muted}} onClick={()=>setModal("notif")}>
              🔔
              <div style={{position:"absolute",top:0,right:0,width:7,height:7,borderRadius:"50%",background:G.accent2,border:`1.5px solid ${G.bg}`}}/>
            </div>
            <div style={{width:34,height:34,borderRadius:"50%",background:`linear-gradient(135deg,${G.accent},${G.accent2})`,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:TNR,fontWeight:700,fontSize:13,cursor:"pointer"}}>{USER.initials}</div>
          </div>
        </div>

        {/* SCREENS — note: all screens are mounted but only one shown, preserving state */}
        <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden"}}>
          <div style={{display:screen==="home"?"flex":"none",flexDirection:"column",flex:1,overflow:"hidden"}}>
            <HomeScreen openModal={id=>setModal(id)}/>
          </div>
          <div style={{display:screen==="subscriptions"?"flex":"none",flexDirection:"column",flex:1,overflow:"hidden"}}>
            <SubscriptionsScreen subs={subs} cancelled={cancelled} onToggleAutopay={handleToggleAutopay} onCancel={handleCancel} openModal={id=>setModal(id)}/>
          </div>
          <div style={{display:screen==="wallet"?"flex":"none",flexDirection:"column",flex:1,overflow:"hidden"}}>
            <WalletScreen subs={subs} onToggleAutopay={handleToggleAutopay} onCancel={handleCancel}/>
          </div>
          <div style={{display:screen==="profile"?"flex":"none",flexDirection:"column",flex:1,overflow:"hidden"}}>
            <ProfileScreen setScreen={setScreen}/>
          </div>
        </div>

        {/* BOTTOM NAV */}
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-around",padding:"12px 0 22px",background:"rgba(19,19,26,0.97)",backdropFilter:"blur(16px)",borderTop:`1px solid ${G.border}`,position:"sticky",bottom:0,zIndex:100}}>
          {TABS.slice(0,2).map(tab=>(
            <div key={tab.id} onClick={()=>setScreen(tab.id)} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:5,cursor:"pointer",padding:"4px 10px",borderRadius:12,background:screen===tab.id?"rgba(108,99,255,0.08)":"transparent"}}>
              <div style={{fontSize:22,opacity:screen===tab.id?1:0.5}}>{tab.icon}</div>
              <div style={{fontSize:13,fontWeight:600,color:screen===tab.id?G.accent:G.muted}}>{tab.label}</div>
            </div>
          ))}
          <div onClick={()=>setModal("pay")} style={{width:52,height:52,borderRadius:16,background:`linear-gradient(135deg,${G.accent},#9b8cff)`,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:22,boxShadow:"0 4px 24px rgba(108,99,255,0.5)",transform:"translateY(-8px)"}}>📤</div>
          {TABS.slice(2).map(tab=>(
            <div key={tab.id} onClick={()=>setScreen(tab.id)} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:5,cursor:"pointer",padding:"4px 10px",borderRadius:12,background:screen===tab.id?"rgba(108,99,255,0.08)":"transparent"}}>
              <div style={{fontSize:22,opacity:screen===tab.id?1:0.5}}>{tab.icon}</div>
              <div style={{fontSize:13,fontWeight:600,color:screen===tab.id?G.accent:G.muted}}>{tab.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* GLOBAL MODALS */}
      <PayModal open={modal==="pay"} onClose={()=>setModal(null)} onSuccess={msg=>{setSuccessMsg(msg);setModal("success");}}/>
      <SuccessModal open={modal==="success"} message={successMsg} onClose={()=>setModal(null)}/>
      <RequestModal open={modal==="request"} onClose={()=>setModal(null)}/>
      <ScanModal open={modal==="scan"} onClose={()=>setModal(null)}/>
      <AddSubModal open={modal==="addSub"} onClose={()=>setModal(null)}/>

      <Modal open={modal==="notif"} onClose={()=>setModal(null)}>
        <div style={{fontFamily:TNR,fontWeight:800,fontSize:20,marginBottom:16}}>Notifications</div>
        {[
          {icon:"✅",bg:"rgba(67,233,123,0.1)",name:"Netflix payment done",sub:"₹649 autopay success · Today"},
          {icon:"⚡",bg:"rgba(247,151,30,0.1)",name:"Spotify due in 4 days",sub:"₹119 · May 8",bdr:"rgba(247,151,30,0.3)"},
          {icon:"💸",bg:"rgba(67,233,123,0.1)",name:"Received ₹2,000 from Priya",sub:"priya.s@payvault · Yesterday"},
          {icon:"🔁",bg:"rgba(108,99,255,0.1)",name:"Autopay mandate updated",sub:"Amazon Prime · 2 days ago"},
        ].map((n,i)=>(
          <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",background:G.card,borderRadius:14,border:`1px solid ${n.bdr||G.border}`,marginBottom:8}}>
            <div style={{width:40,height:40,borderRadius:12,background:n.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{n.icon}</div>
            <div>
              <div style={{fontSize:14,fontWeight:500}}>{n.name}</div>
              <div style={{fontSize:11,color:G.muted,marginTop:2}}>{n.sub}</div>
            </div>
          </div>
        ))}
      </Modal>
    </>
  );
}
